export type Tweet = {
  id: string;
  name: string;
  handle: string;
  avatar: string;
  followers: string;
  text: string;
  likes: string;
  views: string;
  context?: string;
};

export const tweets: Tweet[] = [
  {
    id: "2096403741947613380",
    name: "Solana",
    handle: "solana",
    avatar: "/assets/avatars-bagged/solana.png",
    followers: "4.1M followers",
    text: "Encrypt the memes",
    likes: "941",
    views: "123K",
    context: "The community read it as a perfectly timed ZCAT nod.",
  },
  {
    id: "2096425489392939105",
    name: "Raydium",
    handle: "Raydium",
    avatar: "/assets/avatars-bagged/Raydium.png",
    followers: "457K followers",
    text: "I love cats.",
    likes: "402",
    views: "20K",
  },
  {
    id: "2096386768899637536",
    name: "Ansem",
    handle: "blknoiz06",
    avatar: "/assets/avatars-bagged/blknoiz06-ai.png",
    followers: "1.3M followers",
    text: "zolana needs a runner",
    likes: "2.9K",
    views: "225K",
    context: "Then, replying to @_imagyn: “imagine. $ZCAT.”",
  },
  {
    id: "2096104706162536828",
    name: "imagyn",
    handle: "_imagyn",
    avatar: "/assets/avatars/_imagyn.jpg",
    followers: "8.5K followers",
    text: "There’s also a mechanism baked into the metadata where stonkfun automatically buys and burns the coins, weighted by market dominance.",
    likes: "240",
    views: "8.6K",
    context: "Community mechanics claim. Verify onchain.",
  },
  {
    id: "2096420474913763416",
    name: "Iced",
    handle: "IcedKnife",
    avatar: "/assets/avatars-bagged/IcedKnife.png",
    followers: "366K followers",
    text: "$ZCAT is now my best callout on the pump app. Valuable lesson in holding your conviction bags.",
    likes: "92",
    views: "6.4K",
  },
  {
    id: "2095912908718854381",
    name: "Crypto Curb",
    handle: "CryptoCurb",
    avatar: "/assets/avatars-bagged/CryptoCurb.png",
    followers: "83K followers",
    text: "This token has the most insane rewards mechanism I have ever seen. I made almost $1,000 in $ZEC rewards in the last 24 hours.",
    likes: "203",
    views: "30K",
    context: "Individual result, not a promise of future rewards.",
  },
  {
    id: "2095968831508222411",
    name: "VALUE & TIME",
    handle: "valueandtime",
    avatar: "/assets/avatars-bagged/valueandtime.png",
    followers: "92K followers",
    text: "Made nearly $1,000 overnight in ZEC for holding ZCAT. The bag stays on.",
    likes: "310",
    views: "15K",
    context: "Individual result, not a promise of future rewards.",
  },
  {
    id: "2096069716309680567",
    name: "Klotz",
    handle: "cryptoklotz",
    avatar: "/assets/avatars-bagged/cryptoklotz.png",
    followers: "26K followers",
    text: "The coin could go to zero or a billion. All I know is the bag stays on.",
    likes: "310",
    views: "36K",
  },
  {
    id: "2095949016668250420",
    name: "Mardo",
    handle: "MardoResearch",
    avatar: "/assets/avatars-bagged/MardoResearch.png",
    followers: "11K followers",
    text: "ZCAT pairs privacy-native ZEC culture with an anonymous cat and a holder reward loop.",
    likes: "166",
    views: "17K",
    context: "Condensed from a longer community thesis.",
  },
];
